// @flow

import React, { useContext } from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon'
import Modal from 'react-bootstrap/lib/Modal'
import Button from 'react-bootstrap/lib/Button'

import type { CommonActionProps } from './types.actions'
import type { GridItem } from '../../types'
import ToggleController from '../../controllers/ToggleController'
import ButtonAction from './ButtonAction'
import ItemHistoryModule from '../../modules/itemsHistory'
import OrderItemHistoryModule from '../../modules/orderItemsHistory'
import { DesktopView, MobileView } from '../../config/mediaQuery';
import { ActionsContext } from '../../context/actions.context';

type Props = {
  item: GridItem,
  orderRefetch?: () => {}, 
  removeButton: Boolean,
}

const ItemHistoryAction = (props: CommonActionProps & Props) => {
  const { setFullScreenView , allScreens } = useContext(ActionsContext);
  const accountName = props && props.item && props.item.AcctName;

  const moduleRenderer =
    props.moduleName === 'accounts' ? (
      <ItemHistoryModule isFullPage={false} selectedRow={props.item} accountName={accountName}/>
    ) : (
      <OrderItemHistoryModule
        isFullPage={false}
        selectedRow={props.item}
        orderRefetch={props.orderRefetch}
        accountName={accountName}
      />
    )

  return (
    <ToggleController>
      {({ onToggleVisibility, visible }) => (
        <React.Fragment>
          <DesktopView>
            <ButtonAction
              bsSize={props.size}
              disabled={props.disabled}
              onClick={onToggleVisibility}
            >
              <Glyphicon glyph="time" /> Item History
            </ButtonAction>
          </DesktopView>
          <MobileView>
            <button disabled={props.disabled}
              onClick={onToggleVisibility}>
            {!props.removeButton && <img src={props.moduleName === 'accounts' ? 'assets/history.svg' : 'assets/file-bottom.svg'} alt='item history icon'/>}
            {!props.removeButton && ' Item History'}
            </button>
          </MobileView>
          <DesktopView>
            <Modal bsSize="large" show={visible} onHide={onToggleVisibility}>
              <Modal.Header closeButton>
                <Modal.Title>
                  Item History - {props && props.item && props.item.AcctName}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>{visible && moduleRenderer}</Modal.Body>
              <Modal.Footer>
                <Button onClick={onToggleVisibility}>Close</Button>
              </Modal.Footer>
            </Modal>
          </DesktopView>
          <MobileView>
            {setFullScreenView && !allScreens.find(o => o.view === moduleRenderer) && setFullScreenView(visible ? moduleRenderer : null, "Item History", onToggleVisibility)}
          </MobileView>
        </React.Fragment>
      )}
    </ToggleController>
  )
}

ItemHistoryAction.defaultProps = {
  size: 'xsmall',
}

export default ItemHistoryAction
